
<template>
  <div class="dv-decoration-3" :ref="ref">
    <svg :width="`25px`" :height="`8px`">
        <defs>
            <linearGradient x1="100%" y1="50%" x2="0%" y2="50%" id="linearGradient-3-1">
                <stop stop-color="#1655B0" offset="0%"></stop>
                <stop stop-color="#1655AF" stop-opacity="0" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="切图" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="画板" transform="translate(-30.000000, -179.000000)" fill="url(#linearGradient-3-1)">
                <path d="M55.4257812,179.015625 L55.4257812,187.015625 L50.4257812,187.015625 L50.4257812,179.015625 L55.4257812,179.015625 Z M45.4257812,179.015625 L45.4257812,187.015625 L40.4257812,187.015625 L40.4257812,179.015625 L45.4257812,179.015625 Z M35.4257812,179.015625 L35.4257812,187.015625 L30.4257812,187.015625 L30.4257812,179.015625 L35.4257812,179.015625 Z" id="形状结合" transform="translate(42.925781, 183.015625) scale(-1, 1) translate(-42.925781, -183.015625) "/>
            </g>
        </g>
    </svg>
    <div class="dv-decoration-3-title">
        <span>{{title}}</span>
    </div>
    <svg :width="`115px`" :height="`8px`" v-if="showRight">
        <defs>
            <linearGradient x1="100%" y1="50%" x2="0%" y2="50%" id="linearGradient-3-2">
                <stop stop-color="#1655B0" offset="0%"></stop>
                <stop stop-color="#1655AF" stop-opacity="0" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="切图" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="画板" transform="translate(-188.000000, -181.000000)" fill="url(#linearGradient-3-2)">
                <path d="M303.425781,181.015625 L303.425781,189.015625 L298.425781,189.015625 L298.425781,181.015625 L303.425781,181.015625 Z M293.425781,181.015625 L293.425781,189.015625 L288.425781,189.015625 L288.425781,181.015625 L293.425781,181.015625 Z M283.425781,181.015625 L283.425781,189.015625 L278.425781,189.015625 L278.425781,181.015625 L283.425781,181.015625 Z M273.425781,181.015625 L273.425781,189.015625 L268.425781,189.015625 L268.425781,181.015625 L273.425781,181.015625 Z M263.425781,181.015625 L263.425781,189.015625 L258.425781,189.015625 L258.425781,181.015625 L263.425781,181.015625 Z M253.425781,181.015625 L253.425781,189.015625 L248.425781,189.015625 L248.425781,181.015625 L253.425781,181.015625 Z M243.425781,181.015625 L243.425781,189.015625 L238.425781,189.015625 L238.425781,181.015625 L243.425781,181.015625 Z M233.425781,181.015625 L233.425781,189.015625 L228.425781,189.015625 L228.425781,181.015625 L233.425781,181.015625 Z M223.425781,181.015625 L223.425781,189.015625 L218.425781,189.015625 L218.425781,181.015625 L223.425781,181.015625 Z M213.425781,181.015625 L213.425781,189.015625 L208.425781,189.015625 L208.425781,181.015625 L213.425781,181.015625 Z M203.425781,181.015625 L203.425781,189.015625 L198.425781,189.015625 L198.425781,181.015625 L203.425781,181.015625 Z M193.425781,181.015625 L193.425781,189.015625 L188.425781,189.015625 L188.425781,181.015625 L193.425781,181.015625 Z" id="形状结合"></path>
            </g>
        </g>
    </svg>
  </div>
</template>

<script>
import autoResize from '@jiaminghi/data-view/lib/mixin/autoResize'

import { deepMerge } from '@jiaminghi/charts/lib/util/index'

import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'

export default {
  name: 'DvDecoration3',
  mixins: [autoResize],
  props: {
    color: {
      type: Array,
      default: () => ([])
    },
    title: {
        type: String,
        default: ""
    },
    showRight:{
        type: Boolean,
        default: true
    }
  },
  data () {
    const pointSideLength = 7

    return {
      ref: 'decoration-3',

      svgWH: [300, 35],

      svgScale: [1, 1],

      rowNum: 1,
      rowPoints: 25,

      pointSideLength,
      halfPointSideLength: pointSideLength / 2,

      points: [],

      defaultColor: ['#7acaec', 'transparent'],

      mergedColor: []
    }
  },
  watch: {
    color () {
      const { mergeColor } = this

      mergeColor()
    }
  },
  methods: {
    afterAutoResizeMixinInit () {
      const { calcSVGData } = this

      calcSVGData()
    },
    calcSVGData () {
      const { calcPointsPosition, calcScale } = this

      calcPointsPosition()

      calcScale()
    },
    calcPointsPosition () {
      const { rowNum, rowPoints,width,height } = this
      var rowPointsize = rowPoints
      rowPointsize = Math.round(width/12)
      const horizontalGap = width / (rowPointsize + 1)
      const verticalGap = height / (rowNum + 1)
      let points = new Array(rowNum).fill(0).map((foo, i) =>
        new Array(rowPointsize).fill(0).map((foo, j) => [
            horizontalGap * (j + 1), verticalGap * (i + 1)
        ]))

      this.points = points.reduce((all, item) => [...all, ...item], [])
    },
    calcScale () {
      const { width, height, svgWH } = this

      const [w, h] = svgWH

      this.svgScale = [width / w, height / h]
    },
    onResize () {
      const { calcSVGData } = this

      calcSVGData()
    },
    mergeColor () {
      const { color, defaultColor } = this

      this.mergedColor = deepMerge(deepClone(defaultColor, true), color || [])
    }
  },
  mounted () {
    const { mergeColor } = this

    mergeColor()
  }
}
</script>

<style lang="scss" type="text/scss">
    .dv-decoration-3 {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        .dv-decoration-3-title{
            font-family: PingFangSC-Semibold;
            font-size: 18px;
            color: #4FAEFF;
            letter-spacing: 0;
            text-align: center;
            position:absolute;
            top:7px;
            left: 35px;
        }

    }
    .dv-decoration-3 svg {
        transform-origin: left top;
    }
</style>